import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  Button,
  useToast,
  useDisclosure,
  Text,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

const PedidoNegado = z.object({
  id: z.string().transform((value) => parseInt(value)),
  observacao: z.string(),
})

async function atualizaObservacaoPedidoNegado({ id, observacao }) {
  const res = await api.put('/site/v2/liberacao-pedido/atualiza-observacao-pedido-negado', {
    id,
    observacao,
  })

  return res.data
}

export const ModalObservacao = ({ pedido }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()
  const queryClient = useQueryClient()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(PedidoNegado),
  })

  const numeroPedido = searchParams.get('numero_pedido')

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: atualizaObservacaoPedidoNegado,
    onSuccess: () => {
      toast({
        title: 'Observação salva com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      queryClient.invalidateQueries('pedidos-negados')

      onClose()
    },
    onError: () => {
      toast({
        title: 'Erro ao salvar observação',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  async function handleSaveObservacao(data) {
    await mutateAsync(data)
  }

  console.log(errors)
  useEffect(() => {
    if (numeroPedido) {
      onOpen()
    }
  }, [numeroPedido, onOpen])

  console.log(pedido)

  return (
    <>
      <Button onClick={onOpen}>
        <Text isTruncated maxW="200px" w="full">
          {pedido.observacao}
        </Text>
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(handleSaveObservacao)}>
          <ModalHeader>Adicionar Observação - {numeroPedido}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <input type="hidden" {...register('id')} value={pedido.id} />
            <Textarea placeholder="Digite a observação" {...register('observacao')} />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} mr="2">
              Cancelar
            </Button>
            <Button type="submit" isLoading={isLoading} colorScheme="blue">
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
